import {
  boardConstants,
  laneConstants,
  todoConstants,
  todoMainConstants,
} from '../constants';

const initialState = {
  // main init
  error: null,
  isEdit: false,
  activeView: todoMainConstants.BOARDS_VIEW,

  board: null,
  boardForm: null,
  isFetchingBoard: false,

  boards: [],
  boardsLoaded: 0,
  boardsTotalResults: 0,
  isFetchingBoards: false,
  isFetchingBoardsFrom: 0,

  lane: null,
  laneForm: null,
  isFetchingLane: false,

  todo: null,
  todoForm: null,
  isFetchingTodo: false,
};

export default function todo(state = initialState, action) {
  switch (action.type) {
    // Main Actions
    case todoMainConstants.HANDEL_SET_VIEW:
      return { ...state, activeView: action.payload };

    case todoMainConstants.HANDEL_SET_EDIT:
      return { ...state, isEdit: action.payload };

    case todoMainConstants.HANDEL_SET_FORM:
      return { ...state, [action.formName]: action.formData };

    // Board Actions

    case boardConstants.GETTING_BOARDS_STARTED:
      return {
        ...state,
        isFetchingBoards: true,
        isFetchingBoardsFrom: action.from || 0,
      };
    case boardConstants.GETTING_BOARDS_FAILURE:
      return { ...state, isFetchingBoards: false, error: action.message || '' };
    case boardConstants.GETTING_BOARDS_SUCCESS:
      return {
        ...state,
        isFetchingBoards: false,
        boards:
          action.from > 0 ? [...state.boards, ...action.boards] : action.boards,
        boardsLoaded:
          action.from > 0
            ? state.boards.length + action.boards.length
            : action.boards.length,
        boardsTotalResults: action.totalResults || 0,
      };

    case boardConstants.GET_BOARD_STARTED:
      return { ...state, isFetchingBoard: true };
    case boardConstants.GET_BOARD_FAILURE:
      return { ...state, isFetchingBoard: false, error: action.message || '' };
    case boardConstants.GET_BOARD_SUCCESS:
      return {
        ...state,
        isFetchingBoard: false,
        board: action.board,
      };

    case boardConstants.CREATING_BOARD_STARTED:
      return { ...state, isFetchingBoard: true };
    case boardConstants.CREATING_BOARD_FAILURE:
      return { ...state, isFetchingBoard: false, error: action.message || '' };
    case boardConstants.CREATING_BOARD_SUCCESS:
      return {
        ...state,
        isFetchingBoard: false,
        board: action.board,
        boards: [action.board, ...state.boards],
      };

    case boardConstants.UPDATING_BOARD_STARTED:
      return { ...state, isFetchingBoard: true };
    case boardConstants.UPDATING_BOARD_FAILURE:
      return { ...state, isFetchingBoard: false, error: action.message || '' };
    case boardConstants.UPDATING_BOARD_SUCCESS:
      return {
        ...state,
        isFetchingBoard: false,
        isFetchingTodo: false,
        board: action.board,
        boards: [...state.boards].map((board) => {
          if (action.board.id === board.id) {
            return action.board;
          }
          return board;
        }),
      };

    //    Lane actions

    case todoMainConstants.HANDEL_SET_LANE:
      return { ...state, lane: action.value };
    case laneConstants.LANE_ACTION_STARTED:
      return { ...state, isFetchingLane: true };
    case laneConstants.LANE_ACTION_FAILED:
      return { ...state, isFetchingLane: false, error: action.message || '' };
    case laneConstants.CREATE_LANE_SUCCESS:
      return {
        ...state,
        isFetchingLane: false,
        board: action.board,
        boards: [...state.boards].map((board) => {
          if (action.board.id === board.id) {
            return action.board;
          }
          return board;
        }),
      };
    case laneConstants.UPDATING_LANE_SUCCESS:
      return {
        ...state,
        isFetchingLane: false,
        board: {
          ...state.board,
          lanes: [...state.board.lanes].map((lane) => {
            return lane.id === action.id ? action : lane;
          }),
        },
      };

    case laneConstants.DELETE_LANE_STARTED:
      return {
        ...state,
        isFetchingLane: true,
      }

    case laneConstants.DELETE_LANE_SUCCESS:
      return {
        ...state,
        isFetchingLane: false,
        board: {
          ...state.board,
          lanes: [...state.board.lanes].filter((lane) => lane.id !== action.id),
        },
      };

    case laneConstants.DELETE_LANE_FAILURE:
      return {
        ...state,
        isFetchingLane: false,
      }

    // todos action
    case todoConstants.TODO_ACTION_STARTED:
      return { ...state, isFetchingTodo: true };
    case todoConstants.TODO_ACTION_FAILED:
      return { ...state, isFetchingTodo: false, error: action.message || '' };
    case todoConstants.CREATE_TODO_SUCCESS:
      return {
        ...state,
        isFetchingTodo: false,
        board: {
          ...state.board,
          lanes: [...state.board.lanes].map((lane) => {
            return lane.id === action.id ? action : lane;
          }),
        },
      };
    case todoConstants.UPDATING_TODO_SUCCESS:
      return {
        ...state,
        isFetchingTodo: false,
        board: {
          ...state.board,
          lanes: [...state.board.lanes].map((lane) => {
            if (lane.id === action.laneId) {
              return Object.assign({}, lane, {
                toDos: lane.toDos.map((todo) =>
                  todo.id === action.todo.id ? action.todo : todo
                ),
              });
            }
            return lane;
          }),
        },
      };

    default:
      return state;
  }
}
